import sendRequest from "../../../helpers/requestHelper";
import config from "../../../config";
import eventBus from "../../../event-bus/eventBus";
import {handleError} from "../../../helpers/handleError";

const updateProjectEntry = {
    namespaced: true,
    state: {
        projectEntryDataReceive: {},
        isProjectEntryUpdate: false,
        projectEntryDataIsUpdating: false,
        textInfoProjectEntryUpdate: "",
        headInfoProjectEntryUpdate: "",
        typeInfoProjectEntryUpdate: "",
    },
    mutations: {
        SUCCESS_UPDATE_REPORT_ENTRY(state, response) {
            state.projectEntryDataReceive = {
                title: response.data.message,
                text: response.data.data.textInfo
            };
            state.textInfoProjectEntryUpdate = "";
            state.headInfoProjectEntryUpdate = "";
            state.typeInfoProjectEntryUpdate = "";
            state.projectEntryDataIsUpdating = false;
            eventBus.$emit("saveOrUpdateProjectEntrySuccess", state.projectEntryDataReceive);
        },
        FAILURE_UPDATE_REPORT_ENTRY(state, error) {
            state.textInfoProjectEntryUpdate = handleError(error) !== "" ? handleError(error) : error.response.data.data.message;
            state.typeInfoProjectEntryUpdate = "red";
            state.headInfoProjectEntryUpdate = error.response.data.message;
            state.isProjectEntryUpdate = true;
            state.projectEntryDataIsUpdating = false;
            eventBus.$emit("showSnackbarError", state.projectEntryDataReceive);
        },
        UPDATE_VISIBLE_MODAL(state, value) {
            state.isProjectEntryUpdate = value;
        },
    },
    actions: {
        updateProjectEntry: function({ dispatch, state }, payload) {
            let promise = sendRequest("put", config.baseURLApi + "/projectReportEntries/" + payload.creds.id, {}, payload.creds);
            state.projectEntryDataIsUpdating = true;
            promise.then(function (result) {
                if(result[0] === "success") {
                    dispatch("successUpdateReportEntry", result[1]);
                } else {
                    dispatch("failureUpdateReportEntry", result[1]);
                }
            })
        },
        successUpdateReportEntry: function({ commit }, response) {
            commit("SUCCESS_UPDATE_REPORT_ENTRY", response);
        },
        failureUpdateReportEntry: function({ commit }, response) {
            commit("FAILURE_UPDATE_REPORT_ENTRY", response);
        },
        updateVisibleModalUpdate: function({ commit }, value) {
            commit("UPDATE_VISIBLE_MODAL", value);
        }
    }
}

export default updateProjectEntry;